import React, { useState, useEffect } from "react";
import { Form ,Image,Card} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import {  Link } from "react-router-dom";

const App = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [jsonData, setJsonData] = useState([]);
  const [error, setError] = useState(null);

  // Fetch data from Binance API
  const fetchData = async () => {
    try {
      const response = await axios.get("https://www.binance.com/fapi/v1/premiumIndex");
      setJsonData(response.data); // Axios auto-parses JSON
    } catch (error) {
      setError("Failed to fetch data. Please try again.");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Filtering data based on the search input
  const filteredData = jsonData.filter((item) =>
    item.symbol.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <h2>Search Binance Data (API)</h2>

      <Form.Control
        type="text"
        placeholder="Search by symbol..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          fontSize: "16px",
          marginBottom: "10px",
        }}
      />

      {error && <p style={{ color: "red" }}>{error}</p>}

      <ul style={{ listStyleType: "none", padding: 0 }}>
        {filteredData.length > 0 ? (
          filteredData.map((item) => (
            <Card>
            <Link to={`/Calculate?id=${item.symbol}`} 
              key={item.symbol}
              style={{
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
                marginBottom: "5px",
                backgroundColor: "#f9f9f9",
               
                textDecoration: "none",
           
              }}
            >
        
          <Image style={{width:'40px'}} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRf8zZB9DO67Gc-WHlbBzqU2qq3_43bkXp6kaWt2svjstnWsxo9iSYaK1HO8SY7s1JS7_4&usqp=CAU" roundedCircle />

              <strong style={{color:'black'}}>  &nbsp;{item.symbol}</strong>
              </Link>
              </Card>
         
          ))
        ) : (
          <li>No results found.</li>
        )}
      </ul>
    </div>
  );
};

export default App;
